<template>
  <span :class="className">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.57627 9.32201H6.13327V8.94501C6.13327 7.93101 6.48427 7.38501 7.56327 6.70901C8.36927 6.20201 8.61627 5.76001 8.61627 5.21401C8.61627 4.23901 7.82327 3.84901 6.87427 3.84901C5.66527 3.84901 5.13227 4.48601 5.08027 5.60401H3.57227C3.65027 3.70601 4.76827 2.54901 6.88727 2.54901C8.91527 2.54901 10.2023 3.56301 10.2023 5.20101C10.2023 6.04601 9.86427 6.76101 8.95427 7.35901L8.34327 7.76201C7.71927 8.16501 7.57627 8.45101 7.57627 9.17901V9.32201ZM7.69327 12H6.02927V10.362H7.69327V12Z"
        fill="#667488" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'QuestionMarkInfoIcon',
  props: {
    width: {
      type: String,
      default: '16px'
    },
    height: {
      type: String,
      default: '16px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Add any custom styles here */
</style>